
var QQurl = 'https://static.qcplay.com/kol/jump_03.html'    // 加入qq群
var api = "//api.qingcigame.com"; // 链接
var initialSlide = 0;

var game_id = 33;
var tap_url = 'https://poster.taptap.cn/appsem/149961-apk.html?t=auto_iem_exch-resource_fh665plc_5659_id149961';
var appo_url = 'https://tideng.qingcigame.com/appointment/';
var quantity = '';
var obj = {
    index: function() {
        this.preloading(); // 预加载
        this.indexAjax(); // 首页二维码数据
        this.bind(); // 绑定
    },
    m_index: function() {
        this.m_preloading();
        this.indexAjax(); // 首页二维码数据
        this.bind(); // 绑定
        this.m_tabMain(); // 移动端
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time b').fadeOut();
            $('.loding_time span').addClass('hidden');

            $('.start').fadeIn(); 
            setTimeout(function() {
                $('.start').addClass('start-Ani');
            },200)
            
            this.indexSwiper();
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '',
            // 首页
        ]);
    },
        // 首页二维码数据
    indexAjax: function() {
        var index = layer.load(2, { shade: [0.1, '#fff'] });

        function configInfo() {
            $.ajax({
                url: api + "/web/configInfo?game_id=33",
                type: "GET",
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    var list = json.data.list;

                    if (json.code == 200) {
                        // 下载图片
                        $('.img-download').attr('src', list.down_image_url)
                    }

                },
                error: function() {
                    layer.msg("服务器请求失败", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        }
        configInfo()

        // 下载链接
        function download() {
            $.ajax({
                type: "get",
                url: 'https://api.qingcigame.com/get_url?game_id=' + game_id + '',
                dataType: 'json',
                success: function(json) {
                    // 苹果下载
                    $('.app-btn').attr('href', json.data.ios_down_url);
                    // 安卓下载
                    $('.and-btn').attr('href', json.data.android_down_url);
                    // taptap下载
                    $('.taptap-btn').attr('href', tap_url);
                    // 木木下载
                    $('.mumu-btn').attr('href', json.data.mumu_down_url);
                    // 预约跳转地址
                    $('.appointment-btn').attr('href', appo_url);
                    // 雷电下载
                    $('.thunder-btn').attr('href', json.data.thunder_down_url);

                    // 移动端设备
                    if (/(iphone)/i.test(navigator.userAgent)) {
                        //苹果用户下载
                        $('.download-btn').attr('url_data', json.data.ios_down_url);
                        return
                    } else {
                        //安卓用户下载
                        $('.download-btn').attr('url_data', json.data.android_down_url);
                        return
                    }

                }
            })
        }
        download();

        // 点击下载
        $('.download-btn').click(function(event) {
            var url_data = $(this).attr('url_data');
            var ua = navigator.userAgent.toLowerCase();
            // 微信
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                $('.download-wrap').fadeIn();
                return
            } else {
                location.href = url_data
            }
        });

        // 关闭下载提示
        $('.download-wrap').on('click', function() {
            $(this).fadeOut();
        });
    },
    // 首页轮播
    indexSwiper: function() {
        function swiperMain() { 
            var mySwiper = new Swiper('.swiper-container', {
                direction: 'vertical',
                slidesPerView: 'auto',
                paginationClickable: true,
                spaceBetween: 0,
                mousewheelControl: true,
                resistanceRatio: 0,
                onInit: function(swiper) {
                    swiperAnimate(swiper);

                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            mySwiper.slideTo(page, 1000, true);
                        });
                    };

                    function navLink() {
                        for (var i = 4; i >= 0; i--) {
                            Ani('.nav-0' + i + '', i - 1);
                        };
                    }
                    navLink();

                    $('.return-top').on('click', function() {
                        $('.float-nav li a').removeClass('on');
                        $('.nav-01 a').addClass('on')
                        mySwiper.slideTo(0, 1000, true);
                    });
                },
                onTransitionStart: function(swiper) {
                    swiperAnimate(swiper);
                },
                onSlideChangeEnd: function(swiper) {
                    var ac_index = swiper.activeIndex + 1;
                    $('.float-nav li a').removeClass('on');
                    $('.nav-0' + ac_index + ' a').addClass('on')
                },
            });
        }

        // 点击立即点灯
        $('.start-btn').click(function(event) {
            $('.loding_time').fadeOut();
                setTimeout(function() {
                swiperMain();
                $('.preloading').addClass('preloading-ani').fadeOut(800);
                $('.index').addClass('index-show');
                $('.video-start video').trigger('play');
                setTimeout(function() {
                    $('.video-start').fadeOut();
                },500)
            },500)
        });

        // 左侧二维码自动显示
        setTimeout(function() {
            $('.float-code').addClass('float-l-ani');
            $('.float-nav').addClass('float-r-ani')
        }, 3500);

        function tabSwiperTwo(swiperClass, swiperPagin, stretchX, depthX) {
            var swiper3 = new Swiper(swiperClass, {
                loop: true,
                autoplay: 3000,
                pagination: '.swiper-pagination',
                effect: 'coverflow',
                grabCursor: true,
                centeredSlides: true,
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                slidesPerView: 'auto',
                coverflow: {
                    rotate: 0, // 旋转的角度
                    stretch: stretchX, // 拉伸   图片间左右的间距和密集度
                    depth: depthX, // 深度   切换图片间上下的间距和密集度
                    modifier: 3, // 修正值 该值越大前面的效果越明显
                }
            });
        }
        if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) {
            // pc端
            tabSwiperTwo('.swiper-container-02', '.swiper-pagination', '121', '230');
        } else {
            // 移动端
            tabSwiperTwo('.swiper-container-02', '.swiper-pagination', '20', '30');
        }
    },
    // 绑定
    bind: function() {
        outside.share('https://static.qcplay.com/common/td_icon.png', '提灯与地下城', '深渊黑暗 记得提灯');

        // 玩法介绍
        $('.introduce-column').on('click', 'li', function(event) {
            var _thisData = $(this).attr('data');
            console.log(_thisData);
            $('.introduce-wrap').fadeIn().find('.popup_content').addClass('popup_content-'+_thisData+'');
            openA();
        });

        // 点击关闭弹窗
        $('.introduce-wrap .close-bg').click(function(event) {
            for (var i = 1; i < 6; i++) {
                $('.popup_content').removeClass('popup_content-'+i+'');
            };
        });

        //适龄弹窗
        $('.year_box').on('click', function(event) {
            $('.year_pop').fadeIn();
        });

        $('.sim-btn').on('click', function(event) {
            $('.sim-download-wrap').fadeIn();
        });

        // 关闭动画
        function close() {
            $('.popup_wrap').fadeOut().find('.popup_box').removeClass('ani');
        }

        // 点击关闭弹窗
        $('.close-bg, .close-btn').click(function(event) {
            close();
        });

        // 开启动画
        function openA() {
            setTimeout(function() {
                if (!!window.ActiveXObject || "ActiveXObject" in window) {
                    $('.popup_box').addClass('ani-ie');
                } else {
                    $('.popup_box').addClass('ani');
                }
            }, 200);
            setTimeout(function() {
                $('.close').addClass('closeAni')
            }, 300);
        }

        // 关闭动画
        function close() {
            $('.popup_wrap').fadeOut().find('.popup_box').removeClass('ani');
        }
    },
    // 图片资源预加载
    m_preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        queue.on("progress", function(e) {
            //加载中的进度
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
            // console.log(numbers);

        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            //加载完成执行操作
            $('.loding_time b').fadeOut();
            $('.loding_time span').addClass('hidden');

            $('.start').fadeIn(); 
            setTimeout(function() {
                $('.start').addClass('start-Ani');
            },200)
            
            this.indexSwiper();
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '',
        ]);
    },
    m_tabMain: function() {
        $('.main-wrap').on('click', 'li', function(event) {
            $(this).parent('.main-wrap').hide().siblings().children('ul').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });

        $('.c-ul').on('click', function(event) {
            $('.main-wrap').show().siblings().children('ul').removeClass('show');
        });

        if (/(iphone)/i.test(navigator.userAgent)) {
            //苹果用户-添加app商城跳转
            $('.successful-wrap').addClass('add-app-link');
            return
        };
    },
}